import type { ReactNode } from 'react';
import loadable from '@loadable/component';
import type { ScoreProps } from '@/components/Score';
import DeprecatedKeyMetric from '@/components/DeprecatedKeyMetric';
import {
  SnowflakeScore,
  SectionTitle,
  Description,
  ScoreLabel,
} from './styled';
import DeferRenderUntilIntersecting from '@components/DeferRenderUntilIntersecting';
const Score = loadable(() => import('@components/Score'), { ssr: false });

export interface ReportSectionHeaderProps {
  title: ReactNode;
  score?: number;
  keyMetric?: string | null;
  keyMetricTitle?: string | null;
  sectionDescription?: string;
  scoreValues?: ScoreProps['values'];
  skipDefer?: boolean;
  children?: ReactNode;
}

const ReportSectionHeader = ({
  title = '',
  score,
  keyMetric,
  keyMetricTitle,
  sectionDescription = '',
  scoreValues,
  skipDefer,
  children,
}: ReportSectionHeaderProps) => {
  return (
    <>
      {typeof title === 'string' ? <SectionTitle>{title}</SectionTitle> : title}
      {sectionDescription && (
        <>
          <Description>{sectionDescription}</Description>
          {score !== undefined && score > -1 && (
            <DeferRenderUntilIntersecting skipDefer={skipDefer}>
              {() => (
                <SnowflakeScore>
                  <h4>
                    Analysis Checks <ScoreLabel>{score}/6</ScoreLabel>
                  </h4>
                  <Score values={scoreValues} />
                </SnowflakeScore>
              )}
            </DeferRenderUntilIntersecting>
          )}
          {keyMetric && keyMetric.length > 0 && (
            <>
              <DeprecatedKeyMetric
                title={keyMetricTitle || `Key Metric`}
                size="largest"
                metric={keyMetric}
              />
            </>
          )}
        </>
      )}
      {children}
      <hr />
    </>
  );
};

export default ReportSectionHeader;
